import { css } from '@emotion/css'
import { borderRadius, breakpoint, colors, hexToRgba, mediaQueryHelper, spacing } from '@offerzen/pinata'

const styles = {
  wrapper: css({
    position: 'absolute',
    top: `calc(100% - ${spacing.small}px)`,
    backgroundColor: colors.white,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.medium,
    boxShadow: `0 2px 10px ${hexToRgba(colors.black, 0.07)}`,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    zIndex: 9,
    [mediaQueryHelper(breakpoint.tablet)]: {
      top: '100%',
    },
  }),

  filterWrapper: css({
    position: 'relative',
    marginRight: 0,
    [mediaQueryHelper(breakpoint.tablet)]: {
      marginRight: 10,
      width: '100%',
      maxWidth: 200,
    },
  }),

  body: css({
    height: '100%',
    overflowY: 'auto',
  }),
}

const placement = placement => {
  switch (placement) {
    case 'right':
      return css({
        right: spacing.large,
        left: spacing.large,
        [mediaQueryHelper(breakpoint.tablet)]: {
          right: 0,
          left: 'unset',
        },
      })

    case 'left':
    default:
      return css({
        right: spacing.large,
        left: 0,
        [mediaQueryHelper(breakpoint.tablet)]: {
          left: 0,
          right: 'unset',
        },
      })
  }
}

const size = size => {
  switch (size) {
    case 'small':
      return css({
        width: `calc(100% - ${spacing.extraSmall}px)`,
        [mediaQueryHelper(breakpoint.tablet)]: {
          width: 350,
        },
      })

    case 'large':
      return css({
        width: `calc(100% - ${spacing.large * 2}px)`,
        [mediaQueryHelper(breakpoint.tablet)]: {
          width: 600,
        },
      })

    default:
      return css({
        width: `calc(100% - ${spacing.large * 2}px)`,
        [mediaQueryHelper(breakpoint.tablet)]: {
          width: 410,
        },
      })
  }
}

const sticky = sticky => {
  if (sticky) {
    return css({
      // Calculation is the height of the filter bar - the height of the pill - the padding around it - the height of the label
      maxHeight: `calc(100vh - 100% - ${spacing.medium * 2}px - ${spacing.default}px)`,
    })
  }

  return css({
    // Calculation is the height of the filter bar - the height of the pill - the padding around it - the height of the label - the tabs and navbar
    maxHeight: `calc(100vh - 100% - ${spacing.medium * 2}px - ${spacing.default}px - 111px)`,
  })
}

export { styles, placement, size, sticky }
